import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { TableBuilder, TableBuilderColumn } from 'baseui/table-semantic';
import { ProjectContext } from '../../ProjectApp/context';
import { useAdjustments } from './AdjustmentContext';
const AdjustmentTable = () => {
  const [css] = useStyletron();
  const projectCtx = useContext(ProjectContext);
  const {
    activeType,
    displayedAdjustments
  } = useAdjustments();
  const originalPrice = activeType === 'client_price' ? +projectCtx.clientPrice() : +projectCtx.partnerPrice();
  const originalPriceItem = {
    reason: 'Original Price',
    amount: originalPrice,
    created_date: new Date(projectCtx.createdDate()) // TODO: this should be activated date
  };
  const costSum = displayedAdjustments.reduce((a, b) => a + b.amount, 0);
  const totalPriceItem = {
    reason: 'Total Price',
    amount: originalPrice + costSum,
    created_date: new Date(projectCtx.createdDate())
  };
  const data = [...displayedAdjustments, originalPriceItem].sort((a, b) => a.created_date.getTime() - b.created_date.getTime());
  data.push(totalPriceItem);
  return <TableBuilder data={data} overrides={{
    TableBodyCell: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px'
      }
    }
  }}>
      <TableBuilderColumn header="Date">
        {row => <p data-testid="adjustment-date">
            {row.created_date.toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })}
          </p>}
      </TableBuilderColumn>
      <TableBuilderColumn header="Amount">
        {row => <p data-testid="adjustment-amount">
            {projectCtx.currency()}
            {row.amount.toLocaleString('en-GB', {
          minimumFractionDigits: 2
        })}
          </p>}
      </TableBuilderColumn>
      <TableBuilderColumn header="Reason">
        {row => <p className={css({
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        width: '100%'
      })} data-testid="adjustment-reason">
            {row.reason}
          </p>}
      </TableBuilderColumn>
      <TableBuilderColumn header="Added By">
        {row => <p data-testid="adjustment-actor">{row.actor}</p>}
      </TableBuilderColumn>
    </TableBuilder>;
};
export default AdjustmentTable;